export default {
  largeScreenBreakpoint: 1280,
  desktopBreakpoint: 992,
  tabletBreakpoint: 768
};



// WEBPACK FOOTER //
// ./webpack/components/variables.js